import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({

  state: {
    baseUrl: process.env.VUE_APP_API_URL, // AWS API
    memberStatusUrl: 'status/', // 会員ステータス取得
    storeId: '',
    lineId: '',
    line_platform: {
      redirect_uri: process.env.VUE_APP_REDIRECT_URI, // LINE Developersコンソールに登録したコールバックURL
    },
  },
  mutations: {
    setStoreId (state, value) {
      state.storeId = value
    },
    setLineId (state, value) {
      state.lineId = value
    },
  },
  actions: {
  },
  modules: {}, 
  plugins: [createPersistedState()]
})
